var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#ED1C24;stroke-width:4.3599;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_955",
    className: "st0",
    d: "M27.8,7.9L7.2,27.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1015",
    className: "st0",
    d: "M7.2,7.9l20.6,19.2"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 683 384)",
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 12
    }
  }, "ed1c24"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 683 384)",
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 12
    }
  }, "ed1c24"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.49594f88900c5ea7e6306d6e47b9ac21.svg";
export { ForwardRef as ReactComponent };